import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {WindowGrid} from '../model/common.model';

interface Message<T> {
  key: string;
  data: T;
}

@Injectable({
  providedIn: 'root'
})
export class EventBusService {
  // 存储值方便订阅时获取最后一次发送的值
  private eventMessages = new Map<string, BehaviorSubject<Message<any>>>();
  constructor() {
  }

  /**
   * 通用事件订阅
   * 入参：
   * {
   *  key: 'event', // 事件名
   *  value: '', // 发布的参数
   * }
   */
  public commonEvent: BehaviorSubject<any> = new BehaviorSubject({});
  /**
   * 模板渲染事件
   */
  public templateRenderingEvent: BehaviorSubject<any> = new BehaviorSubject(null);
  /**
   * 登录成功事件
   */
  public loginEvent: BehaviorSubject<any> = new BehaviorSubject({});
  /**
   * 登出事件
   */
  public logOutEvent: BehaviorSubject<any> = new BehaviorSubject({});
  /**
   * 登录二维码弹窗显示
   */
  public wxQrCodeEvent: BehaviorSubject<boolean> = new BehaviorSubject(null);
  /**
   * 获取用户个人信息事件
   */
  public userInfoEvent: BehaviorSubject<any> = new BehaviorSubject({});
  /**
   * 导航事件
   */
  public navigationEvent: BehaviorSubject<any> = new BehaviorSubject({});
  /**
   * 切换语言
   */
  public languageEvent: BehaviorSubject<any> = new BehaviorSubject({});
  /**
   * 窗口大小变化
   */
  public onWindowResizeEvent: BehaviorSubject<{ grid: WindowGrid, width: number, height: number } | any> = new BehaviorSubject(null);

  /**
   *
   * @param key 事件名 如果是后台绑定key那种需要由b组件反向推送 则约定 key为 `return${key}`
   * @param data
   */
  sendEventMessage<T>(key: string, data: T): void {
    if (!this.eventMessages.has(key)) {
      this.eventMessages.set(key, new BehaviorSubject<Message<T>>({ key, data }));
    }
    const subject = this.eventMessages.get(key);
    subject?.next({ key, data });
  }

  observeEventMessages<T>(key: string): any {
    if (!this.eventMessages.has(key)) {
      this.eventMessages.set(key, new BehaviorSubject<Message<T>>({ key, data: null }));
    }
    return this.eventMessages.get(key)?.asObservable();
  }
}
